module.exports = __webpack_public_path__ + "static/img/case3.875eaf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coorperation/case3.png
// module id = P/qO
// module chunks = 6